/**
 * User utility functions
 */

/**
 * Check if the provided user matches the current user
 * @param currentUser - The current logged-in user (name or email)
 * @param targetUser - The user to compare against (name or email)
 * @returns true if the users match, false otherwise
 */
export const isCurrentUser = (currentUser: string, targetUser: string | null | undefined): boolean => {
  if (!currentUser || !targetUser) {
    return false;
  }
  
  // Normalize both strings for comparison (trim and case-insensitive)
  const normalizedCurrent = currentUser.trim().toLowerCase();
  const normalizedTarget = targetUser.trim().toLowerCase();
  
  return normalizedCurrent === normalizedTarget;
};

